
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to scroll to top when navigating
  const handleNavigation = () => {
    setIsMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={handleNavigation}>
            <img 
              src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/133a8deae29cbecd66fda83e37f51621.png" 
              alt="Tecnutri" 
              className="h-10"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Início
            </Link>
            <Link to="/sobre" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Sobre
            </Link>
            <Link to="/produtos" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Produtos
            </Link>
            <Link to="/receitas" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Receitas
            </Link>
            <Link to="/catalogos" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Catálogos
            </Link>
            <Link to="/noticias" className="text-gray-700 hover:text-red-600 transition-colors font-medium cursor-pointer" onClick={handleNavigation}>
              Notícias
            </Link>
          </nav>

          {/* Contact Button */}
          <div className="hidden md:block">
            <Link 
              to="/contato" 
              className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
              onClick={handleNavigation}
            >
              Fale Conosco
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-600 hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Início
              </Link>
              <Link 
                to="/sobre" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Sobre
              </Link>
              <Link 
                to="/produtos" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Produtos
              </Link>
              <Link 
                to="/receitas" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Receitas
              </Link>
              <Link 
                to="/catalogos" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Catálogos
              </Link>
              <Link 
                to="/noticias" 
                className="text-gray-700 hover:text-red-600 transition-colors font-medium px-2 py-1 cursor-pointer"
                onClick={handleNavigation}
              >
                Notícias
              </Link>
              <Link 
                to="/contato" 
                className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors font-medium text-center mt-4 cursor-pointer"
                onClick={handleNavigation}
              >
                Fale Conosco
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
